import { useBackend } from "../../services";
import { EquipmentStatus } from "../equipments";

export const useModifyGearItem = () => {
  const { put } = useBackend();
  const modifyGearItem = (parameters: IModifyGearItemParameters) => put("gearItems", parameters);
  return { modifyGearItem };
};

export interface IModifyGearItemParameters {
  uuid: string;
  name: string;
  hasImage: boolean;
  brand?: string;
  description?: string;
  status: EquipmentStatus;
}
